<template>
    <div class="recordDetail">
        <div id="navTitle">
            <img class="black" @click="back" src="@/assets/images/template/a_top_return.png"/>
            <span>{{$t("recharge.goCharge")}}</span>
            <a @click="goRecord">{{$t("recharge.details")}}</a>
        </div>
        <div id="content">
            <div class="annotate" @click="explainTip()"><span>{{$t("recharge.transferNotice")}}:</span><img src="@/assets/images/despite/icon_yiwen.png"/></div>
            <div class="money">
                <ul>
                    <li><span>{{$t("recharge.transferDeposit")}}({{detailData.payCurrency}})</span><p class="color" id="count">{{count}}</p></li>
                    <li>
                        <span class="size"><em>{{amount}}</em><img @click="changePop($t('recharge.transferDeposit'),amount)" src="@/assets/images/despite/icon_bianji_w.png"/></span>
                        <p class="copy" :data-clipboard-text="amount" @click="copyTxt('.copy')">{{$t("recharge.transferCopy")}}</p>
                    </li>
                </ul>
            </div>
            <div class="desDetail">
                <ul>
                    <li><span>{{$t("recharge.tranferDe")}}</span></li>
                    <li><p>{{$t("recharge.supplyNum")}}</p><p>{{detailData.pno}}</p></li>
                    <li @click="selectDepositMethod"><p>{{$t("recharge.rechargeMethod")}}</p><p>{{bankPayMethodName}}<img src="@/assets/images/template/right_next_step.png"/></p></li>
                    <li @click="selectTime"><p>{{$t("recharge.rechargeTime")}}</p><p>{{timeData}}<img src="@/assets/images/template/right_next_step.png"/></p></li>
                </ul>
            </div>
            <div class="copyDetail">
                <ul>
                    <li>
                        <div class="item"><p>{{$t("recharge.transferBank")}}</p></div>
                        <div class="item"><p>{{detailData.accountname}}</p></div>
                        <div class="item"><span class="transferBank" :data-clipboard-text="detailData.accountname" @click="copyTxt('.transferBank')">{{$t("recharge.transferCopy")}}</span></div>
                    </li>
                    <li>
                        <div class="item"><p>{{$t("recharge.transferAdd")}}</p></div>
                        <div class="item"><p>{{detailData.bankaddress}}</p></div>
                        <div class="item"><span class="transferAdd" :data-clipboard-text="detailData.bankaddress" @click="copyTxt('.transferAdd')">{{$t("recharge.transferCopy")}}</span></div>
                    </li>
                    <li>
                        <div class="item"><p>{{$t("recharge.transferReci")}}</p></div>
                        <div class="item"><p>{{detailData.bankname}}</p></div>
                        <div class="item"><span class="transferReci" :data-clipboard-text="detailData.bankname" @click="copyTxt('.transferReci')">{{$t("recharge.transferCopy")}}</span></div>
                    </li>
                    <li>
                        <div class="item"><p>{{$t("recharge.transferAcc")}}</p></div>
                        <div class="item"><p>{{detailData.accountnumber}}</p></div>
                        <div class="item"><span class="transferAcc" :data-clipboard-text="detailData.accountnumber" @click="copyTxt('.transferAcc')">{{$t("recharge.transferCopy")}}</span></div>
                    </li>
                    <li>
                        <div class="item"><p>{{$t("recharge.transferNote")}}</p></div>
                        <div class="item change">
                            <p>{{transferNotes}}</p>
                            <img @click="changePop($t('recharge.transferNote'),transferNotes)" src="@/assets/images/despite/icon_bianji.png"/>
                        </div>
                        <div class="item"><span class="transferNote" :data-clipboard-text="transferNotes" @click="copyTxt('.transferNote')">{{$t("recharge.transferCopy")}}</span></div>
                    </li>
                </ul>
            </div>
            <div class="explain"><p>{{$t("message.point")}}:</p><p>{{$t("recharge.submitTransferInfo")}}</p></div>
            <div class="btn" @click="submit"><span>{{$t("recharge.deposited")}}</span></div>
            <div class="prompt">{{promptMsg}}</div>
        </div>
        <selectBox v-if="show" :show="show" :list="payWayData" @change="change" @cancel="cancel"></selectBox>
        <TimeAll v-if="isTime" :show="isTime" @changeTime="changeTime" @cancelTime="cancelTime"></TimeAll>
        <!--重要提示-->
        <div class="popFixed" v-if="isExplainPop">
            <div class="masking" @click="explainTip()"></div>
            <div class="tcCon">
                <div class="item">
                    <span>{{$t("message.point")}}</span>
                    <p>{{$t("recharge.tranferNoticeDetail")}}</p>
                </div>
                <div class="btnCon only">
                    <span @click="explainTip()">{{$t("message.definite")}}</span>
                </div>
            </div>
        </div>
        <!--复制提示-->
        <div class="popFixed" v-if="isCopyPop">
            <div class="masking" @click="copyTip()"></div>
            <div class="tcCon">
                <div class="item">
                    <span>{{$t("message.point")}}</span>
                    <p>{{copyTipTxt}}</p>
                </div>
                <div class="btnCon only">
                    <span @click="copyTip()">{{$t("message.definite")}}</span>
                </div>
            </div>
        </div>
        <div class="popFixed" v-if="isShowPop">
            <div class="masking" @click="changePop"></div>
            <div class="tcCon">
                <div class="itemPop">
                    <span>{{titleTxt}}</span>
                    <input v-if="isNum" type="number" v-model="popTxt"  oninput = "value=value.replace(/[^\d^\.]+/g,'')"/>
                    <input v-else type="text" v-model="popTxt"/>
                </div>
                <div class="btnCon">
                    <span @click="changePop">{{$t("message.cancel")}}</span>
                    <span @click="saveChangeTxt">{{$t("message.submit")}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    require('@/assets/css/recordDetail.css');
    import selectBox from '@/view/recharge/select.vue'
    import TimeAll from '@/view/recharge/TimeAll.vue'
    import Clipboard from "clipboard";
    import util from '@/utils/tradeDataUtil'
    import api from '@/plugins/api'
    import {mapState} from 'vuex'

    export default {
        name: "rechargeResult",
        components: {selectBox,TimeAll},
        ...mapState(['user','timeData',"locale"]),
        computed: {
            ...mapState(['user']),
            depositParam: {
                get() {
                    let customerInfo = 'A95 ' + this.detailData.accountNo + ' | '+ this.user.englishFirstName +' '+ this.user.englishLastName + ' | ' + this.detailData.accountname + ' | ' + this.detailData.bankname + ' | ' + this.bankPayMethodName + ' | ' + this.timeData + ' | ' + this.amount + ' | ' + this.transferNotes;
                    return {
                        pno: this.detailData.pno,
                        bankname: this.detailData.bankname,
                        accountnumber: this.detailData.accountnumber,
                        bankaddress: this.detailData.bankaddress,
                        payAmount: this.amount,
                        bankcode: this.detailData.bankcode,
                        bankPayMethod: this.bankPayMethod,
                        depositTime: new Date(this.timeData).getTime(),
                        remark: customerInfo,
                        transferNotes: this.transferNotes,
                    }
                }
            }
        },
        data() {
            return {
                Util: util,
                pno: this.$route.query.pno || "",
                isExplainPop: false,
                amount: "",
                detailData: "",
                bankPayMethodName: this.$t('recharge.onlinebank'),
                bankPayMethod: "P",
                transferNotes: "",
                addressDetail: "",
                count: '',
                counts: '',
                timer: null,
                isCopyPop: false,
                copyTipTxt: "",
                payWayData: [
                    {text: this.$t('recharge.onlinebank'), label: 'P'},
                    {text: this.$t('recharge.atm'), label: 'ATM'},
                    {text: this.$t('recharge.counterDeposit'), label: 'RE'},
                    {text: this.$t('recharge.other'), label: 'O'},
                ],
                show: false,
                timeData: "",
                isTime: "",
                isShowPop: false,
                popTxt: "",
                titleTxt: "",
                isNum:false,
                promptMsg:"",
            }
        },
        methods: {
            back() {
                window.removeEventListener("scroll", this.pullingUpNews);
                this.$router.go(-1);
            },
            removeFixed() {
                let mainH = document.getElementById("main");
                mainH.classList.remove('mainFixed');
            },
            toggleFixed() {
                let mainH = document.getElementById("main");
                mainH.classList.toggle('mainFixed');
            },
            goRecord() {
                this.$bus.$emit('loading', false);
                this.$router.push({path: '/home/record'})
            },
            changePop(type, val) {
                this.toggleFixed();
                this.isShowPop = !this.isShowPop;
                this.titleTxt = type;
                this.popTxt = val;
                if (type == this.$t("recharge.transferDeposit")) {
                    this.isNum = true
                } else this.isNum = false
            },
            saveChangeTxt() {
                this.isShowPop = false;
                this.toggleFixed();
                if (this.titleTxt == this.$t("recharge.transferDeposit")) this.amount = this.popTxt;
                else if (this.titleTxt == this.$t('recharge.transferNote')) this.transferNotes = this.popTxt;
            },
            explainTip() {
                this.toggleFixed();
                this.isExplainPop = !this.isExplainPop;
            },
            copyTip() {
                this.toggleFixed();
                this.isCopyPop = !this.isCopyPop;
            },
            initRechargeDetails() {
                let data = {pno: this.pno};
                api.getRechargeDetailsByPno(this.$qs.stringify(data)).then(res => {
                    if (res.status == 200 && res.data.code == 200) {
                        if (res.data.data) {
                            this.detailData = res.data.data;
                            this.amount = res.data.data.payAmount;
                            this.transferNotes = res.data.data.transferNotes;
                            this.timeData = this.Util.formatDate(res.data.data.nowDate, "yyyy-MM-dd hh:mm:ss");
                            this.timeDiff(res.data.data.createTime, res.data.data.nowDate)
                        }
                    }
                })
            },
            timeDiff(startTime, endTime) {
                let time = Number(3600000);
                let diffTime = this.Util.accSub(time, this.Util.accSub(endTime, startTime));   //时间差的毫秒数
                if (diffTime > 0) {
                    this.countDown(diffTime)
                }
            },
            countDown(time) {
                if (this.Util.isNotEmpty(document.getElementById("count"))) {
                    if (!this.timer) {
                        this.counts = time;
                        this.timer = setInterval(() => {
                            if (this.counts > 0 && this.counts <= time) {
                                this.counts -= 1000;
                                this.count = this.Util.formatToMMSS(this.counts);
                            } else {
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    }
                }
            },
            copyTxt(type) {
                let clipboard = new Clipboard(type);
                clipboard.on("success", e => {
                    this.toggleFixed();
                    this.isCopyPop = true;
                    this.copyTipTxt = this.$t("recharge.transferSucc");
                    clipboard.destroy();
                });
                clipboard.on("error", e => {
                    this.toggleFixed();
                    this.isCopyPop = true;
                    this.copyTipTxt = this.$t("recharge.copyMessages");
                    clipboard.destroy();
                });
            },
            selectDepositMethod() {
                this.show = true;
            },
            change(data) {
                this.bankPayMethodName = data.name;
                this.bankPayMethod = data.id
            },
            cancel(show) {
                this.show = show
            },
            selectTime() {
                this.isTime = true;
            },
            changeTime(data) {
                this.timeData = data.format("Y-MM-dd hh:mm:ss");
            },
            cancelTime(show) {
                this.isTime = show
            },
            submit() {
                this.$bus.$emit('loading', false);
                if (parseFloat(this.amount).toString().length<10){
                    api.addRechargeVoucher(this.$qs.stringify(this.depositParam)).then(res => {
                        if (res.data.code == 200 && res.data.code_desc == "success") {
                            this.$router.push({path: '/home/rechargeResult', query: {type: 1}})
                        }
                    })
                }else {
                    this.$bus.$emit('loading', true);
                    this.promptMsg = this.$t('recharge.rechargeTxt')
                }
            },
        },
        mounted() {
            this.$bus.$emit('loading', true);
            this.removeFixed();
            this.initRechargeDetails();
        },
    }
</script>
